export const fmtDoneAt = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
};

export const titleCase = (s) =>
  (s || "").toLowerCase().replace(/(^|\s|&)([a-z])/g, (m, p, c) => p + c.toUpperCase());
